import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { RadarLegendQuadrant } from './RadarLegendQuadrant.esm.js';
import { setupSegments } from './utils.esm.js';

const useStyles = makeStyles((theme) => ({
  quadrant: {
    height: "100%",
    width: "100%",
    overflowY: "auto",
    scrollbarWidth: "thin"
  },
  quadrantHeading: {
    pointerEvents: "none",
    userSelect: "none",
    marginTop: 0,
    marginBottom: theme.spacing(2),
    fontSize: "18px"
  },
  rings: {
    columns: 3
  },
  ring: {
    breakInside: "avoid-column",
    pageBreakInside: "avoid",
    "-webkit-column-break-inside": "avoid",
    fontSize: "12px",
    marginBottom: theme.spacing(2)
  },
  ringEmpty: {
    color: theme.palette.text.secondary,
    fontSize: "12px"
  },
  ringHeading: {
    pointerEvents: "none",
    userSelect: "none",
    marginTop: 0,
    marginBottom: theme.spacing(1),
    fontSize: "12px",
    fontWeight: 800
  },
  ringList: {
    listStylePosition: "inside",
    marginTop: 0,
    paddingLeft: 0,
    fontVariantNumeric: "proportional-nums",
    "-moz-font-feature-settings": "pnum",
    "-webkit-font-feature-settings": "pnum",
    "font-feature-settings": "pnum"
  },
  entry: {
    pointerEvents: "visiblePainted",
    userSelect: "none",
    fontSize: "11px"
  },
  activeEntry: {
    pointerEvents: "visiblePainted",
    userSelect: "none",
    fontSize: "11px",
    background: "#6f6f6f",
    color: theme.palette.common.white
  },
  entryLink: {
    pointerEvents: "visiblePainted",
    cursor: "pointer"
  }
}));
const RadarLegend = ({
  quadrants,
  rings,
  entries,
  onEntryMouseEnter,
  onEntryMouseLeave,
  ...props
}) => {
  const classes = useStyles(props);
  return /* @__PURE__ */ React.createElement("g", { "data-testid": "radar-legend" }, quadrants.map((quadrant) => /* @__PURE__ */ React.createElement(
    RadarLegendQuadrant,
    {
      key: quadrant.id,
      segments: setupSegments(entries),
      quadrant,
      rings,
      classes,
      onEntryMouseEnter,
      onEntryMouseLeave
    }
  )));
};

export { RadarLegend as default };
//# sourceMappingURL=RadarLegend.esm.js.map
